import type { ExternalTableSchema } from '@packages/table-builder';

export const releaseTable: ExternalTableSchema = {
  metadata: {
    title: 'List of Releases',
    entity: 'Release',
    description: 'View all the releases in your company.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/release/release-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      SearchKeyWord: 'table.searchText',
      // Override table-builder default Filter param — release API uses SearchKeyWord only.
      Filter: '',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      ReleaseStatusId: 'filters.statusId',
      ExpectedReleaseDate: 'filters.releaseDate',
    },
    filters: [
      {
        name: 'statusId',
        placeholder: 'Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/release/release-statuses',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
      {
        name: 'releaseDate',
        placeholder: 'Release Date',
        type: 'date',
      },
    ],
  },

  columns: [
    {
      field: 'name',
      header: 'Name',
      sortable: true,
      width: 200,
      visibility: 'locked',
      emptyDisplay: '-',
    },
    {
      field: 'releaseStatusName',
      header: 'Status',
      type: 'badge',
      sortable: false,
      width: 200,
      align: 'center',
      uppercase: false,
      badge: {
        statusMap: {
          Released: 'success',
          RELEASED: 'success',
          Cancelled: 'error',
          CANCELLED: 'error',
          CANCELED: 'error',
          Rejected: 'error',
          REJECTED: 'error',
          Pending: 'info',
          PENDING: 'info',
        },
        displayMap: {
          Released: 'Released',
          RELEASED: 'Released',
          Pending: 'Pending',
          PENDING: 'Pending',
          Cancelled: 'Cancelled',
          CANCELLED: 'Cancelled',
          CANCELED: 'Cancelled',
          Rejected: 'Rejected',
          REJECTED: 'Rejected',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'expectedReleaseDate',
      header: 'Expected Release Date',
      type: 'date',
      sortable: true,
      width: 200,
      align: 'center',
      emptyDisplay: '-',
    },
    {
      field: 'publishDate',
      header: 'Release Date',
      type: 'date',
      sortable: true,
      width: 200,
      align: 'center',
      emptyDisplay: '-',
    },
    {
      field: 'creationTime',
      header: 'Created Date',
      type: 'date',
      sortable: true,
      width: 200,
      align: 'center',
      visibility: 'picker',
      emptyDisplay: '-',
    },
    {
      field: 'items',
      header: '#Items',
      type: 'text',
      sortable: true,
      width: 200,
      emptyDisplay: '-',
    },
    {
      field: 'noOfShares',
      header: '#Shares',
      type: 'text',
      sortable: true,
      width: 200,
      emptyDisplay: '-',
    },
  ],

  actions: {
    row: [
      { id: 'SUMMARY_RELEASE', label: 'Summary' },
      { id: 'EDIT_RELEASE', label: 'Edit' },
      { id: 'RENAME_RELEASE', label: 'Rename' },
      { id: 'DELETE_RELEASE', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'CREATE_RELEASE',
        label: 'Create Release',
        icon: 'add_circle_outline',
      },
      secondary: [
        {
          label: 'Downloads',
          icon: 'download',
          type: 'download',
          children: [{ id: 'DOWNLOAD_TEMPLATE_RELEASE', label: 'Download Template' }],
        },
        {
          label: 'Import',
          icon: 'upload',
          type: 'upload',
          children: [{ id: 'IMPORT_RELEASE', label: 'Import Bulk XLS' }],
        },
      ],
    },
  },

  features: {
    search: { enabled: true, placeholder: 'Search', debounce: 500 },
    filterGrid: { columns: 3 },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: {
      persistenceKey: 'Release',
      resizable: true,
      reorderable: true,
    },
  },
};
